import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import { useFirebase } from 'contexts/FirebaseContext';
import { addDoc, collection } from 'firebase/firestore';
import { useUser } from 'hooks/useUser';
import { EventOccasion } from 'models/EventOccasion';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { EventSettingsDialog } from './dialog/EventSettingsDialog';
export function CreateEventButton() {
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);
  const navigate = useNavigate();
  const db = useFirebase().db;
  const userContext = useUser();

  async function handleCreateEvent(newEvent: Partial<EventOccasion>) {
    const eventsCollection = collection(db, `user/${userContext.user?.uid}/events`);
    const newEventRef = await addDoc(eventsCollection, newEvent);
    navigate(`/events/${newEventRef.id}`);
  }

  function handleOpenDialog() {
    setOpenDialog(true);
  }

  function handleCloseDialog() {
    setOpenDialog(false);
  }

  return (
    <>
      <Button startIcon={<AddIcon />} onClick={handleOpenDialog} variant="contained">
        {t('createEvent', 'Create')}
      </Button>
      <EventSettingsDialog
        open={openDialog}
        onSave={handleCreateEvent}
        onCancel={handleCloseDialog}
      />
    </>
  );
}
